var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Watch } from 'vue-property-decorator';
import LoaderCard from '@/components/loader-card/LoaderCard.vue';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { SkillCategory, SkillCategoryIncludes } from '@/models/SkillCategory';
let SkillSetSelector = class SkillSetSelector extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #region @PropSyncs
        // #endregion
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.selectedAll = false;
        this.isLoading = true;
        this.selected = null;
        this.skillSets = null;
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.fetchSkillSets();
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    close() {
        this.$emit('input', false);
    }
    // #endregion
    // #region Async methods (api calls only)
    async fetchSkillSets() {
        const skillSets = await new SkillCategory().include([SkillCategoryIncludes.SKILLS]).all();
        // Remove Empty sets and sets that are excluded
        this.skillSets = skillSets.filter((skillSet) => {
            return !!(skillSet.skills && skillSet.skills.length);
        });
    }
    // #endregion
    // #region Getters & Setters
    // #endregion
    // #region @Watchers
    onSelectedSubjectsChange(value) {
        this.$emit('update:selectedSkillSet', value);
    }
};
__decorate([
    Watch('selected', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_a = typeof SkillCategory !== "undefined" && SkillCategory) === "function" ? _a : Object]),
    __metadata("design:returntype", void 0)
], SkillSetSelector.prototype, "onSelectedSubjectsChange", null);
SkillSetSelector = __decorate([
    Component({
        components: {
            LoaderCard,
            SelectFilter
        }
    })
], SkillSetSelector);
export default SkillSetSelector;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
